<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      title="用户详情"
      width="80%"
      @close="close"
    >
      <el-descriptions
        class="margin-top"
        :column="2"
        border
      >
      <el-descriptions-item>
          <template #label>
            头像
          </template>
          <el-avatar :size="40" :src="showForm.basic&&showForm.basic.avatar"></el-avatar>
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            昵称
          </template>
          {{showForm.basic&&showForm.basic.name}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            性别
          </template>
          {{showForm.basic&&showForm.basic.sex == 1 ? '先生' : '女士'}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            省份
          </template>
          {{showForm.basic&&showForm.basic.province}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            城市
          </template>
          {{showForm.basic&&showForm.basic.city}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            注册日期
          </template>
          {{moment(showForm.created).format('YYYY-MM-DD')}}
        </el-descriptions-item>
        <!-- 微信开发信息 -->
        <el-descriptions-item>
          <template #label>
            ID
          </template>
          {{showForm.peopleId}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            微信openId
          </template>
          {{showForm.extra&&showForm.extra.weAppOpenId}}
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <el-button @click="close">关闭</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { getPeople } from '@/api/people'
import moment from 'moment'
export default {
  name: 'PeopleDetail',
  emits: ['fetch-data'],
  data() {
    return {
      moment,
      showForm: {},
      dialogFormVisible: false,
    }
  },
  methods: {
    async show(row) {
      const peopleId = row.peopleId
      // const data = await getPeople({
      //   peopleId,
      // })
      this.showForm = row
      this.dialogFormVisible = true
    },
    close() {
      this.dialogFormVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.rich-box {
  overflow: auto;
  max-height: 800px;
}
// .rich-box img{
//     // max-width: 600px !important;
// }
.p-avatar {
  width: 240px;
  height: 160px;
}
.e-carousel {
  width: 240px;
}
.el-row {
  padding: 14px 0;
}
.ml-10 {
  margin-left: 10px;
}
</style>
